import { usePublicCarrierLogos } from '@/models/publicCarrierLogos'
import { CARRIER_LOGOS } from '../content/carrierLogos'
import { LogoGrid, type LogoGridItem } from './LogoGrid'

export interface MarketingCarrierLogosProps {
  heading?: string
  onDark?: boolean
  className?: string
}

/**
 * Falls back to the static bundled logo list whenever the API has nothing usable
 * yet (loading, erroring, or no carrier has a marketing logo uploaded), so an
 * empty/incomplete carrier table never blanks out the marketing page.
 */
export function MarketingCarrierLogos({ heading, onDark, className }: MarketingCarrierLogosProps) {
  const { logos: dynamicLogos, isLoading, isError } = usePublicCarrierLogos()

  const logos: LogoGridItem[] =
    !isLoading && !isError && dynamicLogos && dynamicLogos.length > 0
      ? dynamicLogos.map((carrier) => ({ src: carrier.marketingLogo, alt: carrier.name }))
      : CARRIER_LOGOS

  return <LogoGrid heading={heading} logos={logos} onDark={onDark} className={className} />
}
